"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const falconone_1 = require("../../private/api-services/falconone");
const authData_1 = require("../../private/ephemeral/authData");
class Label {
    constructor() {
        this.domainAuthenticated = false;
        if (!(authData_1.Auth.getUserToken())) {
            throw new Error("Cannot use Label service without authenticated user " +
                "please use the Authenticator service first");
        }
        const domainToken = authData_1.Auth.getDomainToken();
        if (domainToken) {
            this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken(), domainToken);
            this.domainAuthenticated = true;
        }
        else {
            this.api = new falconone_1.FalconOne(authData_1.Auth.getUserToken());
        }
    }
    /**
     * This is the new get domain labels
     * @param query
     */
    all(query) {
        if (!this.domainAuthenticated) {
            throw new Error(` To use this endpoint, you need to have an open domain. (if this error persist, instantiate a new Label instance) `);
        }
        return this.api.getSearchQuery("label", query);
    }
    /**
     * @deprecated
     * @description get domain labels (available for suggestion)
     *
     * @param params { isRoot: boolean }
     * @returns {Promise<iLabel[]>}
     * @memberof Label
     */
    getDomainLabels(params) {
        console.warn('this endpoint is deprecated');
        return this.api.getSearchQuery("label/domain", params);
    }
    getLabelSuggestions(body) {
        return this.api.post("label/suggestions", body);
    }
    getLabelAutomplete(params) {
        return this.api.get("label/autocomplete", params);
    }
    /**
     * Create a new label
     * @param createdLabel
     * @returns {Promise<{iLabel}>}
     */
    create(createdLabel) {
        if (!this.domainAuthenticated) {
            throw new Error(` To use this endpoint, you need to have an open domain. (if this error persist, instantiate a new Label instance) `);
        }
        return this.api.post("label", createdLabel);
    }
    get(labelId) {
        if (!this.domainAuthenticated) {
            throw new Error(` To use this endpoint, you need to have an open domain. (if this error persist, instantiate a new Label instance) `);
        }
        return this.api.get(`label/${labelId}`);
    }
    update(labelId, label) {
        if (!this.domainAuthenticated) {
            throw new Error(` To use this endpoint, you need to have an open domain. (if this error persist, instantiate a new Label instance) `);
        }
        return this.api.patch(`label/${labelId}`, label);
    }
    delete(labelId) {
        if (!this.domainAuthenticated) {
            throw new Error(` To use this endpoint, you need to have an open domain. (if this error persist, instantiate a new Label instance) `);
        }
        return this.api.delete(`label/${labelId}`);
    }
    getLabelChildren(labelId) {
        return this.api.get(`label/${labelId}/children`);
    }
    getLabelMembers(labelId) {
        return this.api.get(`label/${labelId}/members`);
    }
}
exports.Label = Label;
//# sourceMappingURL=data:application/json;base64,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